module.exports = __webpack_public_path__ + "img/isNotOwner.b32b75a3.svg";